// Deprecated. Please refrain from new usage
export default class Vehicle {
  constructor(vehicle) {
    this.vehicle = vehicle;
  }

  static getEarliestStatusTimestamp(vehicle = this.vehicle) {
    if (vehicle.recent_statuses && vehicle.recent_statuses.length) {
      const earliestStatus = vehicle.recent_statuses[vehicle.recent_statuses.length - 1];
      if (earliestStatus) {
        return earliestStatus.timestamp;
      }
    }
    return null;
  }

  /**
   * Returns 'bike' or 'scooter' or null
   * from 'vehicle_api.bike' string
   * @param  {} vehicle
   */
  static getCanonicalType(vehicle = this.vehicle) {
    try {
      return vehicle.type.split(".")[1];
    } catch (err) {
      return null;
    }
  }

  static parseShortcode(vehicle = this.vehicle) {
    if (vehicle.shortcodes.length > 0) {
      return vehicle.shortcodes[0].shortcode;
    }

    // removes everything that isn't a Number
    const stripChars = (string) => string.replace(/\D+/g, "");
    // uses serialNumber as display shortcode
    const serialNumber = parseInt(stripChars(vehicle.serial_number), 10);
    // generates a fake shortcode from the UUID
    const fakeShortcode = stripChars(vehicle.id).substring(0, 3);

    return serialNumber || fakeShortcode;
  }

  // Duplicate because I'm not re-writing timeline-service.
  static availableStates = [
    "offline",
    "available",
    "reserved",
    "fault",
    "unavailable",
    "operator",
    "self_check",
    "firmware_update",
    "out_of_service",
    "charging",
  ];
}
